import { BranchGetAdapter } from '../../../../adapter';

export default async function BranchGetUseCase(event) {
    const { size, page, search } = event;

    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/branch/get';

    const payload = {
        data: {
            branchData: {
                size: size,
                page: page,
                search: search
            },
            signature: ''
        }
    };

    const result = await BranchGetAdapter(requestUrl, JSON.stringify(payload));
    return result;
}
